<template>
    <div :class="accordionClass">
        <p :class="classObject" @click="handleAccordion"> {{ accordionHeader }} </p>
        <div v-show="isOpen" :class="accordionClass + '-content'">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AccordionItem',
        props: {
            accordionClass: {type: String, default: 'accordion-item'},
            accordionHeader: {type: String},
        },
        data(){return{
            isOpen: false,
        }},
        computed:{
            classObject(){
                let headerClass = this.accordionClass + '-header';
                return { [headerClass] : true, 'active' : this.isOpen }
            },
        },
        methods:{
            handleAccordion(){
                this.isOpen = !this.isOpen;
            },
        }
    }
</script>
<style lang="scss">
    @import './AccordionItem.scss';
</style>